import React from 'react';
import Select from 'react-select';
import {
  IconHome,
  IconHome2,
  IconHomeCheck,
  IconBuilding,
  IconBuildingEstate,
  IconBuildingSkyscraper,
  IconBuildingCommunity,
  IconBuildingWarehouse,
  IconBox,
  IconKey,
  IconDoor,
  IconStairs,
  IconElevator,
  IconRuler,
  IconBed,
  IconBath,
  IconSofa,
  IconArmchair,
  IconArmchair2,
  IconToolsKitchen2,
  IconCoffee,
  IconGrill,
  IconGlassFull,
  IconFlame,
  IconWashMachine,
  IconAirConditioning,
  IconSun,
  IconSnowflake,
  IconDroplet,
  IconBolt,
  IconWifi,
  IconDeviceTv,
  IconCar,
  IconCarGarage,
  IconBike,
  IconPlant2,
  IconTrees,
  IconPaw,
  IconBabyCarriage,
  IconMoodKid,
  IconPool,
  IconBarbell,
  IconMassage,
  IconTrophy,
  IconBallTennis,
  IconBallFootball,
  IconBallBasketball,
  IconGolf,
  IconMountain,
  IconMovie,
  IconDeviceGamepad2,
  IconBook,
  IconBriefcase,
  IconUsers,
  IconUser,
  IconUserShield,
  IconShieldCheck,
  IconBan,
  IconBrandAirbnb,
  IconCheck,
  IconCircleCheck,
  IconStar,
  IconSparkles,
  IconHanger,
  IconFridge,
  IconWindow,
  IconEye,
  IconLayoutGrid,
  IconRoad,
  IconFileCheck,
  IconMapPin,
  IconSquare,
  IconBuildingStore,
  IconBeach,
  IconVolcano,
  IconSailboat,
  IconPanoramaHorizontal,
  IconSwimming,
  IconCompass,
  IconSunrise,
  IconSunset,
  IconSunHigh,
  IconStairsUp,
  IconStairsDown,
  IconBuildingBridge,
  IconBuildingCastle,
  IconBuildingLighthouse,
  IconBinoculars,
  IconWind,
  IconWaveSine,
  IconMoon,
  IconLeaf,
  IconFlower,
  IconFence,
  IconDeviceCctv,
  IconLock,
  IconParking,
  IconSolarPanel,
  IconUmbrella,
  IconTemperatureSun,
} from '@tabler/icons-react';

// Íconos de Tabler que se pueden asignar a una característica o amenidad. El
// backend guarda solo el nombre (ej. "IconPool") y el front de la web lo
// resuelve al mismo ícono. Se importan uno a uno (no `import *`) para no meter
// los ~5000 íconos de Tabler al bundle del admin. `label` ayuda a buscarlos en
// español. Para sumar uno: importarlo y agregarlo a la lista.
export const TABLER_ICONS = [
  { name: 'IconHome', label: 'Casa', Icon: IconHome },
  { name: 'IconHome2', label: 'Casa 2', Icon: IconHome2 },
  { name: 'IconHomeCheck', label: 'Casa verificada', Icon: IconHomeCheck },
  { name: 'IconBuilding', label: 'Edificio', Icon: IconBuilding },
  { name: 'IconBuildingEstate', label: 'Edificio residencial', Icon: IconBuildingEstate },
  { name: 'IconBuildingSkyscraper', label: 'Rascacielos, rooftop', Icon: IconBuildingSkyscraper },
  { name: 'IconBuildingCommunity', label: 'Comunidad, salón de eventos', Icon: IconBuildingCommunity },
  { name: 'IconBuildingWarehouse', label: 'Bodega, almacén', Icon: IconBuildingWarehouse },
  { name: 'IconBox', label: 'Caja, bodega', Icon: IconBox },
  { name: 'IconKey', label: 'Llave', Icon: IconKey },
  { name: 'IconDoor', label: 'Puerta', Icon: IconDoor },
  { name: 'IconStairs', label: 'Gradas, pisos', Icon: IconStairs },
  { name: 'IconElevator', label: 'Elevador', Icon: IconElevator },
  { name: 'IconRuler', label: 'Medidas', Icon: IconRuler },
  { name: 'IconBed', label: 'Cama, habitación', Icon: IconBed },
  { name: 'IconBath', label: 'Baño', Icon: IconBath },
  { name: 'IconSofa', label: 'Sala, sofá', Icon: IconSofa },
  { name: 'IconArmchair', label: 'Sillón, área de estar', Icon: IconArmchair },
  { name: 'IconArmchair2', label: 'Sillón 2', Icon: IconArmchair2 },
  { name: 'IconToolsKitchen2', label: 'Cocina, comedor, restaurante', Icon: IconToolsKitchen2 },
  { name: 'IconCoffee', label: 'Café', Icon: IconCoffee },
  { name: 'IconGrill', label: 'Parrilla, BBQ', Icon: IconGrill },
  { name: 'IconGlassFull', label: 'Bar', Icon: IconGlassFull },
  { name: 'IconFlame', label: 'Fuego, sauna', Icon: IconFlame },
  { name: 'IconWashMachine', label: 'Lavadora, área de servicio, línea blanca', Icon: IconWashMachine },
  { name: 'IconAirConditioning', label: 'Aire acondicionado', Icon: IconAirConditioning },
  { name: 'IconSun', label: 'Sol, terraza, balcón', Icon: IconSun },
  { name: 'IconSnowflake', label: 'Frío', Icon: IconSnowflake },
  { name: 'IconDroplet', label: 'Agua, cisterna', Icon: IconDroplet },
  { name: 'IconBolt', label: 'Electricidad', Icon: IconBolt },
  { name: 'IconWifi', label: 'Internet', Icon: IconWifi },
  { name: 'IconDeviceTv', label: 'Televisión', Icon: IconDeviceTv },
  { name: 'IconCar', label: 'Auto', Icon: IconCar },
  { name: 'IconCarGarage', label: 'Parqueo, garaje', Icon: IconCarGarage },
  { name: 'IconBike', label: 'Bicicleta, ciclorruta', Icon: IconBike },
  { name: 'IconPlant2', label: 'Planta, jardín', Icon: IconPlant2 },
  { name: 'IconTrees', label: 'Árboles, zonas verdes', Icon: IconTrees },
  { name: 'IconPaw', label: 'Mascotas', Icon: IconPaw },
  { name: 'IconBabyCarriage', label: 'Guardería', Icon: IconBabyCarriage },
  { name: 'IconMoodKid', label: 'Niños, juegos', Icon: IconMoodKid },
  { name: 'IconPool', label: 'Piscina', Icon: IconPool },
  { name: 'IconBarbell', label: 'Gimnasio', Icon: IconBarbell },
  { name: 'IconMassage', label: 'Spa', Icon: IconMassage },
  { name: 'IconTrophy', label: 'Deportes, canchas', Icon: IconTrophy },
  { name: 'IconBallTennis', label: 'Tenis, pádel', Icon: IconBallTennis },
  { name: 'IconBallFootball', label: 'Fútbol', Icon: IconBallFootball },
  { name: 'IconBallBasketball', label: 'Básquetbol', Icon: IconBallBasketball },
  { name: 'IconGolf', label: 'Golf', Icon: IconGolf },
  { name: 'IconMountain', label: 'Montaña, canopy, escalar', Icon: IconMountain },
  { name: 'IconMovie', label: 'Cine', Icon: IconMovie },
  { name: 'IconDeviceGamepad2', label: 'Videojuegos, arcade', Icon: IconDeviceGamepad2 },
  { name: 'IconBook', label: 'Lectura, biblioteca', Icon: IconBook },
  { name: 'IconBriefcase', label: 'Coworking, negocios', Icon: IconBriefcase },
  { name: 'IconUsers', label: 'Reuniones, grupos', Icon: IconUsers },
  { name: 'IconUser', label: 'Persona', Icon: IconUser },
  { name: 'IconUserShield', label: 'Conserje', Icon: IconUserShield },
  { name: 'IconShieldCheck', label: 'Seguridad, vigilancia', Icon: IconShieldCheck },
  { name: 'IconBan', label: 'Prohibido', Icon: IconBan },
  { name: 'IconBrandAirbnb', label: 'Airbnb', Icon: IconBrandAirbnb },
  { name: 'IconCheck', label: 'Check', Icon: IconCheck },
  { name: 'IconCircleCheck', label: 'Check en círculo', Icon: IconCircleCheck },
  { name: 'IconStar', label: 'Estrella', Icon: IconStar },
  { name: 'IconSparkles', label: 'Destacado', Icon: IconSparkles },
  { name: 'IconHanger', label: 'Closet, ropero', Icon: IconHanger },
  { name: 'IconFridge', label: 'Cocina equipada, refrigerador', Icon: IconFridge },
  { name: 'IconWindow', label: 'Ventana, balcón', Icon: IconWindow },
  { name: 'IconEye', label: 'Vista', Icon: IconEye },
  { name: 'IconLayoutGrid', label: 'Piso, porcelanato', Icon: IconLayoutGrid },
  { name: 'IconRoad', label: 'Calle, carretera', Icon: IconRoad },
  { name: 'IconFileCheck', label: 'Escriturado, documentos', Icon: IconFileCheck },
  { name: 'IconMapPin', label: 'Ubicación, frente a calle', Icon: IconMapPin },
  { name: 'IconSquare', label: 'Forma regular', Icon: IconSquare },
  { name: 'IconBuildingStore', label: 'Zona comercial', Icon: IconBuildingStore },
  { name: 'IconBeach', label: 'Playa, vista al mar', Icon: IconBeach },
  { name: 'IconVolcano', label: 'Volcán, vista al volcán', Icon: IconVolcano },
  { name: 'IconSailboat', label: 'Lago, velero', Icon: IconSailboat },
  { name: 'IconPanoramaHorizontal', label: 'Vista panorámica', Icon: IconPanoramaHorizontal },
  { name: 'IconSwimming', label: 'Natación, vista a la piscina', Icon: IconSwimming },
  { name: 'IconCompass', label: 'Brújula, orientación norte/sur', Icon: IconCompass },
  { name: 'IconSunrise', label: 'Amanecer, orientación este', Icon: IconSunrise },
  { name: 'IconSunset', label: 'Atardecer, orientación oeste', Icon: IconSunset },
  { name: 'IconSunHigh', label: 'Luz natural, sol', Icon: IconSunHigh },
  { name: 'IconStairsUp', label: 'Piso alto, subir gradas', Icon: IconStairsUp },
  { name: 'IconStairsDown', label: 'Planta baja, bajar gradas', Icon: IconStairsDown },
  { name: 'IconBuildingBridge', label: 'Ciudad, puente', Icon: IconBuildingBridge },
  { name: 'IconBuildingCastle', label: 'Castillo, torre', Icon: IconBuildingCastle },
  { name: 'IconBuildingLighthouse', label: 'Faro, mirador', Icon: IconBuildingLighthouse },
  { name: 'IconBinoculars', label: 'Binoculares, mirador', Icon: IconBinoculars },
  { name: 'IconWind', label: 'Viento, ventilación cruzada', Icon: IconWind },
  { name: 'IconWaveSine', label: 'Ondas, agua', Icon: IconWaveSine },
  { name: 'IconMoon', label: 'Luna, noche', Icon: IconMoon },
  { name: 'IconLeaf', label: 'Hoja, ecológico', Icon: IconLeaf },
  { name: 'IconFlower', label: 'Flor, jardín privado', Icon: IconFlower },
  { name: 'IconFence', label: 'Cerca, muro perimetral', Icon: IconFence },
  { name: 'IconDeviceCctv', label: 'Cámaras de seguridad', Icon: IconDeviceCctv },
  { name: 'IconLock', label: 'Candado, acceso controlado', Icon: IconLock },
  { name: 'IconParking', label: 'Estacionamiento de visitas', Icon: IconParking },
  { name: 'IconSolarPanel', label: 'Panel solar', Icon: IconSolarPanel },
  { name: 'IconUmbrella', label: 'Sombrilla, techado', Icon: IconUmbrella },
  { name: 'IconTemperatureSun', label: 'Clima cálido', Icon: IconTemperatureSun },
];

const ICON_BY_NAME: Record<string, React.ElementType> = Object.fromEntries(
  TABLER_ICONS.map(({ name, Icon }) => [name, Icon]),
);

interface TablerIconProps {
  name?: string | null;
  size?: number;
}

/** Dibuja el ícono de Tabler por nombre; si no está en la lista muestra el nombre. */
export const TablerIcon = ({ name, size = 18 }: TablerIconProps) => {
  if (!name) return null;
  const Icon = ICON_BY_NAME[name];
  return Icon ? <Icon size={size} aria-hidden /> : <small className="text-muted">{name}</small>;
};

/** Ícono + texto, para `formatOptionLabel` de react-select. */
export const iconOptionLabel = <T extends { label: string; icon?: string | null }>({
  label,
  icon,
}: T) => (
  <span className="d-flex align-items-center">
    <span className="mr-2 d-inline-flex" style={{ width: 20 }}>
      <TablerIcon name={icon} />
    </span>
    {label}
  </span>
);

interface TablerIconPickerProps {
  value: string;
  onChange: (iconName: string) => void;
  placeholder?: string;
}

/** Selector con búsqueda: cada opción muestra el ícono y su nombre. */
export const TablerIconPicker = ({
  value,
  onChange,
  placeholder = 'Elige un ícono (opcional)',
}: TablerIconPickerProps) => {
  const options = TABLER_ICONS.map(({ name, label }) => ({
    value: name,
    label: `${name.replace(/^Icon/, '')} — ${label}`,
    icon: name,
  }));
  return (
    <Select
      aria-label="Ícono de Tabler"
      placeholder={placeholder}
      isClearable
      options={options}
      value={options.find((option) => option.value === value) ?? null}
      onChange={(selected) => onChange(selected?.value ?? '')}
      formatOptionLabel={iconOptionLabel}
      // misma altura que los inputs de Argon
      styles={{
        control: (base) => ({
          ...base,
          minHeight: 'calc(1.5em + 1.25rem + 2px)',
        }),
      }}
    />
  );
};
